import { JobRequest } from "../../../api-types/job-requests/job-request";
import axios from "../../index";
import { jobRequestUrl } from "../../utils";

export const updateJobRequest = async (jobRequestData: JobRequest) => {
  return await axios.patch(jobRequestUrl(jobRequestData._id), jobRequestData);
};
